export default __webpack_public_path__ + "static/media/bnb-logo.f5dcdcc3.svg";